import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from 'actions/ActionTypes';
import { gcApi } from '../config/axios';

export function* fetchGearsSaga(action) {
    yield put({
        type: types.FETCH_GEARS_FECTHING
    });

    try {
        let url = `/gear-service/gear/filterGear?userProfilePk=${action.userProfilePk}`;
        const response = yield call(gcApi.get, url);

        yield put({ type: types.FETCH_GEARS_SUCCESS, gearsData: response.data, receivedAt: Date.now() });
    } catch (e) {
        yield put({
            type: types.FETCH_GEARS_FAIL,
            gear: {}
        });
    }
}

export const gearsSagas = [takeEvery(types.FETCH_GEARS, fetchGearsSaga)];
